<template>
  <div class="inquiry-page">
    <!-- 顶部导航栏 -->
    <div class="header">
      <div class="back-btn" @click="returnToFrontPage">
        <a-icon type="left" /> 返回
      </div>
      <h3>{{ currentTitle }}</h3>
    </div>

    <!-- 查询表单 -->
    <div v-if="queryVisible" class="form-container">
      <a-form-model ref="queryForm" :model="queryParams" layout="vertical">
        <a-form-model-item label="报事人姓名" prop="reportman">
          <a-input v-model="queryParams.reportman" placeholder="请输入报事人姓名" />
        </a-form-model-item>

        <a-form-model-item label="报事人手机号" prop="reportphone">
          <a-input v-model="queryParams.reportphone" placeholder="请输入报事人手机号" />
        </a-form-model-item>

        <a-form-model-item label="验证码" prop="code">
          <div class="verify-code-wrapper">
            <a-input
                v-model="queryParams.code"
                placeholder="请输入验证码"
                class="code-input"
            />
            <vertify-code ref="vertifyCode" @get-code="getVertifyCode" class="verify-code" />
          </div>
        </a-form-model-item>

        <div class="submit-btn-container">
          <a-button type="primary" block @click="confirm">查询工单</a-button>
        </div>
      </a-form-model>
    </div>

    <!-- 工单列表 -->
    <div v-if="listVisible" class="list-container">
      <div class="list-header">
        <h3>报事工单列表</h3>
      </div>

      <div class="order-list">
        <div
            class="order-item"
            v-for="(item, index) in repairOrderList"
            :key="index"
            @click="selectOneOrder(item)"
        >
          <div class="order-content">
            <div class="order-row">
              <span class="label">报事单号：</span>
              <span class="value">{{ item.order_num }}</span>
            </div>
            <div class="order-row">
              <span class="label">报事时间：</span>
              <span class="value">{{ moment(item.receive_time, 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss') }}</span>
            </div>
            <div class="order-row">
              <span class="label">报事类型：</span>
              <span class="value">{{ item.repair_matter_type }}</span>
            </div>
            <div class="order-row">
              <span class="label">报事内容：</span>
              <span class="value">{{ item.content ? item.content.substring(0, 20) + (item.content.length > 20 ? '...' : '') : '' }}</span>
            </div>
          </div>
          <div class="order-status" :class="getStatusClass(item.process_node)">
            {{ reportStatus[item.process_node] }}
          </div>
          <div v-if="!item.contacts_grade && !item.contacts_evaluation && item.process_node===91" class="order-actions" @click.stop>
            <a-button type="primary" size="small" @click="openEvaluation(item)">
              评价
            </a-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 悬浮查询按钮 -->
    <div v-if="listVisible" class="fab-search" @click="openSearch">
      <a-icon type="search" />
    </div>

    <!-- 查询弹窗 -->
    <a-modal
        :visible="searchVisible"
        title="查询工单"
        :footer="null"
        width="85%"
        @cancel="closeSearch"
    >
      <div style="padding: 8px 0;">
        <a-form-model-item label="报事单号">
          <a-input v-model="searchForm.order_num" placeholder="请输入报修单号" />
        </a-form-model-item>
        <a-form-model-item label="报事时间">
          <a-date-picker v-model="searchForm.receive_time" style="width: 100%" placeholder="请选择报修时间" />
        </a-form-model-item>
        <a-form-model-item label="报事内容">
          <a-input v-model="searchForm.content" placeholder="请输入报修内容" />
        </a-form-model-item>
        <div style="display: flex; gap: 12px; justify-content: center; margin-top: 20px;">
          <a-button @click="closeSearch">取消</a-button>
          <a-button type="primary" @click="doSearch">确定</a-button>
        </div>
      </div>
    </a-modal>

    <!-- 工单详情 -->
    <div v-if="detailVisible" class="detail-container">
      <a-tabs type="card" default-active-key="1">
        <a-tab-pane key="1" tab="报事详情">
          <div class="detail-content">
            <div class="detail-item">
              <span class="detail-label">报事单号</span>
              <span class="detail-value">{{ formData.order_num }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">报事来源</span>
              <span class="detail-value">{{ formData.order_source }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">是否困人</span>
              <span class="detail-value">{{ formData.is_tiring === 1 ? "是" : "否" }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">报事类型</span>
              <span class="detail-value">{{ formData.repair_matter_type }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">重大影响</span>
              <span class="detail-value">{{ bigInfluences[formData.biginfluence] }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">报事人姓名</span>
              <span class="detail-value">{{ formData.contacts }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">报事人手机号</span>
              <span class="detail-value">{{ formData.contact_information }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">流程节点</span>
              <span class="detail-value">{{ repairOrderSteps[formData.process_node] || '' }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">报事内容</span>
              <span class="detail-value">{{ formData.content }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">接报时间</span>
              <span class="detail-value">{{ formData.receive_time ? moment(formData.receive_time, 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss') : '' }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">完成时间</span>
              <span class="detail-value">{{ formData.complete_time ? moment(formData.complete_time, 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss') : '' }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">完成时长</span>
              <span class="detail-value">{{ formData.complete_interval ? turnHHMMss(formData.complete_interval) : "" }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">解困时间</span>
              <span class="detail-value">{{ formData.refresh_time ? moment(formData.refresh_time, 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss') : '' }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">解困时长</span>
              <span class="detail-value">{{ formData.refresh_interval ? turnHHMMss(formData.refresh_interval) : "" }}</span>
            </div>

            <!-- 图片展示区域 -->
            <div class="picture-section" v-if="cameraList.length > 0">
              <h3 class="section-title">现场图片</h3>
              <div class="picture-grid">
                <div v-for="(item, index) in cameraList" :key="index" class="picture-item">
                  <h4 v-if="item.pic_type == '1' || item.pic_type == '2'">
                    {{ item.picTypeName }}
                    <span v-if="item.time_anomaly === '1'" class="time-anomaly">时间异常</span>
                  </h4>
                  <div v-if="item.pic_type == '2'" class="video-container">
                    <video v-for="(cItem, cIndex) in item.list" :key="cIndex" :src="baseurl + cItem.url" controls></video>
                  </div>
                  <a-upload
                      v-if="item.pic_type == '1'"
                      list-type="picture-card"
                      :file-list="item.list"
                      disabled
                      @preview="handlePreview"
                  ></a-upload>
                </div>
              </div>
            </div>
          </div>
        </a-tab-pane>

        <a-tab-pane key="2" tab="事件处理信息" force-render>
          <div class="detail-content">
            <div class="detail-item">
              <span class="detail-label">处理完成时间</span>
              <span class="detail-value">{{ formData.handle_time ? moment(formData.handle_time, 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss') : '' }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">处理时长</span>
              <span class="detail-value">{{ formData.handle_interval ? turnHHMMss(formData.handle_interval) : "" }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">处理内容</span>
              <span class="detail-value" style="white-space: pre-wrap">{{ formData.handle_content }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">处理状态</span>
              <span class="detail-value">{{ formData.handle_status }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">处理人</span>
              <span class="detail-value">{{ formData.handle_person }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">强关理由</span>
              <span class="detail-value" style="white-space: pre-wrap">{{ formData.close_reason }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">驳回理由</span>
              <span class="detail-value" style="white-space: pre-wrap">{{ formData.reject_reason }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">报事人评价</span>
              <span class="detail-value">{{ formData.contacts_grade }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">报事人评价内容</span>
              <span class="detail-value" style="white-space: pre-wrap">{{ formData.contacts_evaluation }}</span>
            </div>

            <!-- 处理图片展示区域 -->
            <div class="picture-section" v-if="cameraList.some(item => item.pic_type > 2)">
              <h3 class="section-title">处理图片</h3>
              <div class="picture-grid">
                <div v-for="(item, index) in cameraList.filter(i => i.pic_type > 2)" :key="index" class="picture-item">
                  <h4 v-if="item.pic_type > 2">
                    {{ item.picTypeName }}
                    <span v-if="item.time_anomaly === '1'" class="time-anomaly">时间异常</span>
                  </h4>
                  <div v-if="item.pic_type == '16' || item.pic_type == '22'" class="video-container">
                    <video v-for="(cItem, cIndex) in item.list" :key="cIndex" :src="cItem.url" controls></video>
                  </div>
                  <a-upload
                      v-if="item.pic_type > 2 && item.pic_type != '16' && item.pic_type != '22'"
                      list-type="picture-card"
                      :file-list="item.list"
                      disabled
                      @preview="handlePreview"
                  ></a-upload>
                </div>
              </div>
            </div>
          </div>
        </a-tab-pane>

        <a-tab-pane key="3" tab="报事追踪">
          <a-timeline class="timeline-container">
            <a-timeline-item
                v-for="(item, index) in workFlow"
                :key="index"
                :color="getTimelineColor(item.status)"
            >
              <div class="timeline-item">
                <div class="timeline-step">操作步骤: {{ repairOrderSteps[item.status] }}</div>
                <div class="timeline-person">操作人员: {{ item.username ? item.username + "（" + item.person + "）" : item.person }}</div>
                <div class="timeline-time">完成时间: {{ item.finish_time ? moment(item.finish_time, 'YYYYMMDDHHmmss').format("YYYY-MM-DD HH:mm:ss") : "" }}</div>
              </div>
            </a-timeline-item>
          </a-timeline>
        </a-tab-pane>
      </a-tabs>
    </div>

    <!-- 图片预览 Modal -->
    <a-modal v-model="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>

    <!-- 评价弹窗 -->
    <a-modal
      :visible="evalVisible"
      title="工单评价"
      :footer="null"
      width="85%"
      @cancel="evalVisible = false"
    >
      <div style="padding: 8px 0;">
        <div style="margin-bottom: 16px;">
          <div style="margin-bottom: 8px; font-weight: 500; color: #333;">评价等级</div>
          <a-radio-group v-model="evalForm.contacts_grade">
            <a-radio value="不及格">不及格</a-radio>
            <a-radio value="及格">及格</a-radio>
            <a-radio value="良好">良好</a-radio>
            <a-radio value="优秀">优秀</a-radio>
          </a-radio-group>
        </div>
        <div style="margin-bottom: 20px;">
          <div style="margin-bottom: 8px; font-weight: 500; color: #333;">评价内容</div>
          <a-textarea
            v-model="evalForm.contacts_evaluation"
            :rows="4"
            placeholder="请输入评价内容"
          />
        </div>
        <a-button type="primary" block @click="submitEvaluation">
          提交评价
        </a-button>
      </div>
    </a-modal>

    <!-- 加载状态 -->
    <a-modal v-model="loadingVisible" :footer="null" :closable="false" class="loading-modal">
      <div class="loading-content">
        <a-spin size="large" />
        <p class="loading-text">正在加载...</p>
      </div>
    </a-modal>

    <!-- 提示信息 -->
    <a-modal v-model="showToast" :footer="null" :closable="false" :zIndex="2000" class="toast-modal">
      <div class="toast-content" :class="toastType">
        <a-icon :type="toastIcon" class="toast-icon" />
        <p class="toast-message">{{ toastMessage }}</p>
      </div>
    </a-modal>
  </div>
</template>
<script>
import moment from "moment/moment";
import {mapGetters, mapState} from "vuex";
import VertifyCode from "C/VertifyCode.vue";
import {
  getRepairsOrderInfoByOrderId,
  getRepairsOrderListByContacts,
  getRepairsOrderPicByOrderId,
  getWorkflowByOrderId,
  evaluationRepairsOrder,
  getRepairsOrderListByCondition
} from "A/thjlcx";
import {mattersPicType, repairOrderSteps} from "@/json/repairsOrderSteps";
export default {
  name: "matter",
  components: {VertifyCode},
  data() {
    return {
      moment,
      queryVisible: true,
      listVisible: false,
      detailVisible: false,
      loadingVisible: false,
      showToast: false,
      toastType: 'success',
      toastMessage: '',
      toastIcon: 'check-circle',

      queryParams: {
        order_type: "0",
        reportman: "",
        reportphone: "",
        code: "",
      },
      vertifyCode: '',
      baseurl: 'https://fda.u-lake.com/',
      previewImage: '',
      previewVisible: false,

      repairOrderList: [],
      reportStatus: {
        '10': '待接单/转单',
        '20': '待处理',
        '30': '待签到',
        '40': '待执行',
        '60': '申请强关中',
        '70': '待结单',
        '80': '待验收',
        '90': '待评价',
        '100': '转第三方处理',
        '101': '转第三方处理',
        '110': '转计划性维修',
        '111': '转计划性维修',
        '201': '驳回申请',
        '11': '派单完成',
        '21': '转单完成',
        '31': '接单完成',
        '41': '签到完成',
        '51': '工单延期',
        '61': '工单强关',
        '71': '处理完成',
        '81': '验收完成',
        '121': '评价完成',
        '91': '结单完成'
      },
      bigInfluences: {
        "1": "无", "2": "电梯困人", "3": "停用电梯", "4": "停电", "5": "发电", "6": "停水", "7": "跑水", "8": "意外伤害", "9": "治安", "10": "群访", "11": "传染病/疫情", "12": "火情"
      },
      repairOrderSteps,
      mattersPicType,
      formData: {},
      cameraList: [],
      workFlow: [],
      evalVisible: false,
      evalForm: {
        order_id: '',
        contacts_grade: undefined,
        contacts_evaluation: '',
      },
      workFlowIndex: 0,
      searchVisible: false,
      searchForm: {
        order_num: '',
        receive_time: null,
        content: '',
      },
    }
  },
  computed: {
    ...mapGetters(['uploadHeaders', 'uploadRepairsData']),
    currentTitle() {
      if (this.queryVisible) return '报事查询';
      if (this.listVisible) return '工单列表';
      if (this.detailVisible) return '工单详情';
      return '报事查询';
    }
  },
  watch: {
  },
  created() {
    this.formData.monitorpointnum=this.$store.state.monitorpointnum
  },
  methods: {
    getVertifyCode(vertifyCode) {
      this.vertifyCode = vertifyCode;
    },
    async handlePreview(item) {
      this.previewImage = item.url;
      this.previewVisible = true;
    },
    handleCancel() {
      this.previewImage = "";
      this.previewVisible = false;
    },
    resetData() {
      this.formData = {};
      this.cameraList = [];
      if (this.$refs.vertifyCode) {
        this.$refs.vertifyCode.refreshCode();
      }
    },
    showLoading() {
      this.loadingVisible = true;
    },
    hideLoading() {
      this.loadingVisible = false;
    },
    showToastMessage(type, message) {
      this.toastType = type;
      this.toastMessage = message;

      if (type === 'success') {
        this.toastIcon = 'check-circle';
      } else if (type === 'warning') {
        this.toastIcon = 'exclamation-circle';
      } else if (type === 'error') {
        this.toastIcon = 'close-circle';
      }

      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
      }, 2000);
    },
    confirm() {
      if (!this.queryParams.reportman || !this.queryParams.reportphone) {
        this.showToastMessage('warning', '请完整填写姓名和手机号');
        return;
      }

      if (this.queryParams.code.toUpperCase() !== this.vertifyCode.toUpperCase()) {
        this.showToastMessage('error', '验证码错误');
        return;
      }

      this.showLoading();
      getRepairsOrderListByContacts({...this.queryParams}).then(res => {
        this.hideLoading();
        if (res && res.returncode === '0') {
          if (res.item.length > 0) {
            this.showToastMessage('success', '查询成功');
            this.repairOrderList = res.item;
            this.queryVisible = false;
            this.listVisible = true;
          } else {
            this.showToastMessage('error', '未查询到报事工单');
          }
        } else {
          this.showToastMessage('error', res.errormsg || '查询失败');
        }
      }).catch(err => {
        this.hideLoading();
        this.showToastMessage('error', '网络错误，请重试');
      });
    },
    returnToFrontPage() {
      if (this.detailVisible) {
        this.detailVisible = false;
        this.listVisible = true;
        return;
      }

      if (this.listVisible) {
        this.listVisible = false;
        this.repairOrderList = [];
        this.queryParams.reportman = "";
        this.queryParams.reportphone = "";
        this.queryParams.code = "";
        if (this.$refs.vertifyCode) {
          this.$refs.vertifyCode.refreshCode();
        }
        this.queryVisible = true;
        return;
      }

      this.$router.back();
    },
    selectOneOrder(item) {
      this.listVisible = false;
      this.showLoading();
      getRepairsOrderInfoByOrderId({order_id: item.order_id}).then(res => {
        this.hideLoading();
        if (res && res.returncode === '0') {
          this.detailVisible = true;
          this.formData = res.item;
          this.getWorkFlow();
          this.getPictureList();
        } else {
          this.showToastMessage('error', res.errormsg || '获取详情失败');
        }
      }).catch(err => {
        this.hideLoading();
        this.showToastMessage('error', '获取详情失败');
      });
    },
    turnHHMMss(time) {
      if (!time) return '';
      let hours = Math.floor(time / 3600);
      let minutes = Math.floor((time % 3600) / 60);
      let seconds = Math.round(time % 60);
      return `${hours}小时${minutes}分钟${seconds}秒`;
    },
    getWorkFlow() {
      let params = {
        order_id: this.formData.order_id
      };
      getWorkflowByOrderId(params).then(res => {
        if (res && res.returncode == '0') {
          this.workFlow = res.item;
          this.workFlow.push({
            status:131,
            finish_time:this.formData.contacts_time,
            username:this.formData.contacts,
            person:this.formData.contacts,
          })
          this.getWorkFlowIndex();
        } else {
          this.showToastMessage('error', res.errormsg || '获取流程失败');
        }
      }).catch(err => {
        this.showToastMessage('error', '获取流程失败');
      });
    },
    getWorkFlowIndex() {
      if (this.formData.process_node && this.workFlow && this.workFlow.length) {
        this.workFlow.forEach((item, index) => {
          if (item.status == this.formData.process_node) {
            this.workFlowIndex = index;
          }
        });
      }
    },
    getPictureList() {
      let params = {
        order_id: this.formData.order_id
      };
      getRepairsOrderPicByOrderId(params).then(res => {
        if (res && res.returncode == '0') {
          let cameraListMap = {};
          res.item.forEach((item, index) => {
            if (!cameraListMap[item.pic_type]) {
              cameraListMap[item.pic_type] = [];
            }
            let obj = {
              ...item,
              uid: 'uid-' + item.pic_type + '-' + index,
              status: 'done',
              url: this.baseurl + item.pic_url,
            };
            let nameIndex = item.pic_url.lastIndexOf('/');
            if (nameIndex < 0) {
              nameIndex = item.pic_url.lastIndexOf('\\');
            }
            if (nameIndex > -1) {
              obj.name = item.pic_url.substr(nameIndex + 1);
            }
            obj.picTypeName = mattersPicType[item.pic_type] || '';
            cameraListMap[item.pic_type].push(obj);
          });

          this.cameraList = [];
          for (let key in cameraListMap) {
            this.cameraList.push({
              pic_type: cameraListMap[key][0].pic_type,
              picTypeName: cameraListMap[key][0].picTypeName,
              list: cameraListMap[key],
              time_anomaly: cameraListMap[key][0].time_anomaly
            });
          }
        } else {
          this.showToastMessage('error', res.errormsg || '获取图片失败');
        }
      }).catch(err => {
        this.showToastMessage('error', '获取图片失败');
      });
    },
    getStatusClass(processNode) {
      const statusMap = {
        '10': 'status-waiting',
        '20': 'status-processing',
        '30': 'status-processing',
        '40': 'status-processing',
        '60': 'status-warning',
        '70': 'status-processing',
        '80': 'status-processing',
        '90': 'status-processing',
        '100': 'status-third',
        '101': 'status-third',
        '110': 'status-plan',
        '111': 'status-plan',
        '201': 'status-reject',
        '11': 'status-completed',
        '21': 'status-completed',
        '31': 'status-completed',
        '41': 'status-completed',
        '51': 'status-delay',
        '61': 'status-close',
        '71': 'status-completed',
        '81': 'status-completed',
        '121': 'status-completed',
        '91': 'status-completed'
      };
      return statusMap[processNode] || 'status-default';
    },
    getTimelineColor(status) {
      if (['10', '20', '30', '40', '70', '80', '90'].includes(status)) {
        return 'blue';
      } else if (['11', '21', '31', '41', '71', '81', '91', '121'].includes(status)) {
        return 'green';
      } else if (['60', '201'].includes(status)) {
        return 'red';
      } else if (['100', '101', '110', '111'].includes(status)) {
        return 'orange';
      }
      return 'gray';
    },
    openEvaluation(item) {
      this.evalForm.order_id = item.order_id;
      this.evalForm.contacts_grade = item.contacts_grade !== undefined ? item.contacts_grade : undefined;
      this.evalForm.contacts_evaluation = item.contacts_evaluation || '';
      this.evalVisible = true;
    },
    submitEvaluation() {
      if (this.evalForm.contacts_grade === undefined || this.evalForm.contacts_grade === null) {
        this.showToastMessage('warning', '请选择评价等级');
        return;
      }
      this.showLoading();
      evaluationRepairsOrder({...this.evalForm}).then(res => {
        this.hideLoading();
        if (res && res.returncode === '0') {
          this.showToastMessage('success', '评价提交成功');
          this.evalVisible = false;
          this.refreshOrderList();
        } else {
          this.showToastMessage('error', res.errormsg || '评价提交失败');
        }
      }).catch(err => {
        this.hideLoading();
        this.showToastMessage('error', '网络错误，请重试');
      });
    },
    refreshOrderList() {
      getRepairsOrderListByContacts({...this.queryParams}).then(res => {
        if (res && res.returncode === '0') {
          this.repairOrderList = res.item;
        }
      });
    },
    openSearch() {
      this.searchVisible = true;
    },
    closeSearch() {
      this.searchVisible = false;
      this.clearSearchForm();
    },
    clearSearchForm() {
      this.searchForm = { order_num: '', receive_time: null, content: '' };
    },
    doSearch() {
      const params = {};
      if (this.searchForm.order_num) params.order_num = this.searchForm.order_num;
      if (this.searchForm.content) params.content = this.searchForm.content;
      if (this.searchForm.receive_time) params.receive_time = moment(this.searchForm.receive_time).format('YYYYMMDDHHmmss');
      this.showLoading();
      getRepairsOrderListByCondition({...params,...this.queryParams}).then(res => {
        this.hideLoading();
        if (res && res.returncode === '0') {
          this.repairOrderList = res.item;
        } else {
          this.showToastMessage('error', res.errormsg || '查询失败');
        }
      }).catch(() => {
        this.hideLoading();
        this.showToastMessage('error', '查询失败');
      });
      this.closeSearch();
    }
  }
}
</script>
<style scoped lang="scss">
.inquiry-page {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding-bottom: 20px;
}

/* 顶部导航 */
.header {
  background: #fff;
  padding: 15px;
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

  .back-btn {
    color: #1890ff;
    font-size: 16px;
    cursor: pointer;
    margin-right: auto;
    display: flex;
    align-items: center;
  }

  h3 {
    margin: 0;
    font-weight: 600;
    color: #333;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    font-size: 18px;
  }
}

/* 表单容器 */
.form-container {
  background: #fff;
  margin: 10px;
  padding: 20px;
  border-radius: 8px;

  ::v-deep .ant-form-item {
    margin-bottom: 16px;
  }

  ::v-deep .ant-input {
    height: 40px;
    border-radius: 4px;
  }
}

/* 验证码布局 */
.verify-code-wrapper {
  display: flex;
  gap: 10px;
  align-items: center;
}
.code-input {
  flex: 1;
}
.verify-code {
  width: 120px;
  height: 40px;
}

/* 提交按钮 */
.submit-btn-container {
  margin-top: 24px;
}

/* 列表容器 */
.list-container {
  background: #fff;
  margin: 10px;
  padding: 16px;
  border-radius: 8px;

  .list-header {
    padding: 8px 0;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 16px;
  }
}

.fab-search {
  position: fixed;
  right: 20px;
  bottom: 120px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #1890ff;
  color: #fff;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.4);
  cursor: pointer;
  z-index: 99;
}

/* 工单列表项 */
.order-list {
  .order-item {
    padding: 16px;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    margin-bottom: 12px;
    background: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    position: relative;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    .order-content {
      .order-row {
        display: flex;
        margin-bottom: 4px;
        font-size: 14px;

        .label {
          color: #999;
          min-width: 80px;
        }

        .value {
          flex: 1;
          color: #333;
        }
      }
    }

    .order-actions {
      margin-top: 12px;
      padding-top: 10px;
      border-top: 1px solid #f0f0f0;

      .ant-btn {
        border-radius: 4px;
      }
    }

    .order-status {
      position: absolute;
      right: 12px;
      top: 12px;
      padding: 2px 8px;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 500;

      &.status-waiting { background: #fffbe6; color: #faad14; }
      &.status-processing { background: #e6f7ff; color: #1890ff; }
      &.status-completed { background: #f6ffed; color: #52c41a; }
      &.status-warning { background: #fff2e8; color: #fa8c16; }
      &.status-reject { background: #fff2f0; color: #ff4d4f; }
      &.status-third { background: #f9f0ff; color: #722ed1; }
      &.status-plan { background: #e6f7ff; color: #13c2c2; }
      &.status-delay { background: #fffbe6; color: #faad14; }
      &.status-close { background: #f0f0f0; color: #666; }
      &.status-default { background: #f0f0f0; color: #666; }
    }
  }
}

/* 详情容器 */
.detail-container {
  background: #fff;
  margin: 10px;
  border-radius: 8px;
  overflow: hidden;

  ::v-deep .ant-tabs {
    .ant-tabs-nav {
      margin: 0;
      background: #f8f9fa;
      border-bottom: 1px solid #e8e8e8;
    }

    .ant-tabs-content {
      padding: 16px;
    }
  }
}

/* 详情内容 */
.detail-content {
  background: #fff;
}

.detail-item {
  display: flex;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  min-height: 40px;

  &.full-width {
    flex-direction: column;
    align-items: flex-start;
  }

  .detail-label {
    color: #666;
    font-weight: 500;
    min-width: 100px;
    margin-right: 16px;
  }

  .detail-value {
    flex: 1;
    color: #333;
    word-break: break-all;
  }
}

/* 图片区块 */
.picture-section {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;

  .section-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
    color: #333;
  }

  .picture-grid {
    display: grid;
    gap: 16px;

    .picture-item {
      h4 {
        margin: 0 0 8px 0;
        font-size: 14px;
        color: #333;
      }

      .time-anomaly {
        color: #ff4d4f;
        font-size: 12px;
        margin-left: 8px;
      }

      .video-container {
        video {
          width: 100%;
          max-height: 200px;
          margin-bottom: 8px;
        }
      }
    }
  }
}

/* 时间轴 */
.timeline-container {
  background: #fff;
  padding: 16px;

  ::v-deep .ant-timeline-item {
    padding-bottom: 16px;

    .timeline-item {
      background: #f9f9f9;
      padding: 12px;
      border-radius: 8px;
      border-left: 3px solid #1890ff;

      .timeline-step {
        font-weight: 500;
        margin-bottom: 4px;
      }

      .timeline-person {
        color: #666;
        margin-bottom: 4px;
        font-size: 14px;
      }

      .timeline-time {
        color: #999;
        font-size: 13px;
      }
    }
  }
}

/* 加载和提示样式 */
.loading-modal {
  ::v-deep .ant-modal-content {
    background: transparent;
    box-shadow: none;
  }
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;

  .loading-text {
    margin-top: 12px;
    color: #666;
    font-size: 14px;
  }
}

.toast-modal {
  ::v-deep .ant-modal-content {
    background: transparent;
    box-shadow: none;
  }
}

.toast-content {
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  max-width: 280px;
  margin: 0 auto;

  &.success {
    background: rgba(82, 196, 26, 0.85);
  }

  &.warning {
    background: rgba(250, 173, 20, 0.85);
  }

  &.error {
    background: rgba(255, 77, 79, 0.85);
  }

  .toast-icon {
    font-size: 20px;
    margin-right: 10px;
  }

  .toast-message {
    margin: 0;
    font-size: 14px;
    line-height: 1.4;
  }
}
</style>